import "../shared/IntakeProgressBar.scss";

import React from "react";

interface IntakeProgressBarProps {
  progress: number; // 0-100
  className?: string;
  showPercentage?: boolean;
  height?: string;
  backgroundColor?: string;
  fillColor?: string;
}

const IntakeProgressBar: React.FC<IntakeProgressBarProps> = ({
  progress,
  className = "",
  showPercentage = false,
  height = "8px",
  backgroundColor = "#e0e0e0",
  fillColor = "#007bff",
}) => {
  // ensure progress is between 0 and 100
  const normalizedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div className={`progress-bar-container ${className}`}>
      {showPercentage && (
        <div className="progress-percentage">
          {Math.round(normalizedProgress)}%
        </div>
      )}
      <div
        className="progress-bar-track"
        style={{
          height,
          backgroundColor,
        }}
      >
        <div
          className="progress-bar-fill"
          style={{
            width: `${normalizedProgress}%`,
            backgroundColor: fillColor,
            height: "100%",
          }}
        />
      </div>
    </div>
  );
};

export default IntakeProgressBar;
